import { NgComponentOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ExperimentCreateComponent } from '@components/experiment-create/experiment-create.component';
import { ExperimentCreateDetailsModule } from '../experiment-create-details/experiment-create-details.module';
import { ExperimentCreateImportDatasetModule } from '../experiment-create-import-dataset/experiment-create-import-dataset.module';

@NgModule({
    declarations: [ExperimentCreateComponent],
    exports: [ExperimentCreateComponent],
    imports: [ExperimentCreateDetailsModule, ExperimentCreateImportDatasetModule, MatIconModule, MatToolbarModule, NgComponentOutlet]
})
export class ExperimentCreateModule { }